import { render, staticRenderFns } from "./FilesForm.vue?vue&type=template&id=bf35476a&scoped=true&"
import script from "./FilesForm.vue?vue&type=script&lang=js&"
export * from "./FilesForm.vue?vue&type=script&lang=js&"
import style0 from "./FilesForm.vue?vue&type=style&index=0&id=bf35476a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf35476a",
  null
  
)

export default component.exports